import { gsap } from 'gsap'
import { Timeline } from 'gsap/gsap-core'
import { unpackPotentialRef } from './unpackPotentialRef'

const elementOfPotentialComponent = (potentialComponent) => (potentialComponent && '$el' in potentialComponent ? potentialComponent.$el : potentialComponent)

const parseTargets = (targets) => (Array.isArray(targets) ? targets.map(unpackPotentialRef).map(elementOfPotentialComponent) : elementOfPotentialComponent(unpackPotentialRef(targets)))

// Allow refs to be passed as targets to keep timeline code clean on the component side.
;['set', 'to', 'from', 'fromTo', 'add'].forEach((key) => {
  const originalMethod = Timeline.prototype[key]
  Timeline.prototype[key] = function (targets, ...args) {
    return originalMethod.apply(this, [parseTargets(targets), ...args])
  }
})

gsap.registerEffect({
  name: 'startInvisible',
  extendTimeline: true,
  effect: function (target) {
    return gsap.from(parseTargets(target), { visibility: 'hidden', duration: 0.0000001 })
  },
})

gsap.registerEffect({
  name: 'endInvisible',
  extendTimeline: true,
  effect: function (target) {
    return gsap.to(parseTargets(target), { autoAlpha: 0, duration: 0.0000001 }, '>')
  },
})

export default gsap
